var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.746 0.266951C21.6221 0.143825 21.4656 0.0585764 21.2949 0.0212298C21.1242 -0.0161169 20.9464 -0.00400938 20.7824 0.0561287L0.59226 7.38908C0.418137 7.45505 0.268227 7.57236 0.162442 7.72544C0.0566557 7.87852 0 8.06012 0 8.24612C0 8.43213 0.0566557 8.61373 0.162442 8.76681C0.268227 8.91988 0.418137 9.0372 0.59226 9.10316L8.47557 12.2472L14.294 6.41747L15.588 7.7099L9.74204 13.5488L12.899 21.4225C12.967 21.5931 13.0848 21.7393 13.2369 21.8423C13.3891 21.9452 13.5687 22.0002 13.7525 22C13.938 21.9962 14.1179 21.9364 14.2687 21.8284C14.4194 21.7204 14.5338 21.5693 14.5968 21.395L21.9387 1.2294C22.0012 1.06723 22.0163 0.890647 21.9822 0.720241C21.9481 0.549835 21.8661 0.392629 21.746 0.266951Z",
    fill: "url(#paint0_linear_600_821)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_600_821",
    x1: 0,
    y1: 11,
    x2: 22,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send_message.93cfee909615e62bada8af7c2b5f0f59.svg";
export { ForwardRef as ReactComponent };